import { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ProductSize } from '../../types/product-sizes.type';

type ProductSizeChipProps = {
  size: ProductSize;
};

const useStyles = makeStyles(() => ({
  root: (props: { backgroundColor: string }) => ({
    borderRadius: 4,
    backgroundColor: props.backgroundColor,
    color: '#ffffff',
    fontWeight: 600,
    fontSize: 12,
  }),
}));

const SIZE_COLORS: Record<ProductSize, string> = {
  S: '#4caf50',
  M: '#2196f3',
  L: '#ff9800',
  XL: '#f44336',
  SOLO: '#9c27b0',
};

export default function ProductSizeChip({ size }: ProductSizeChipProps) {
  const backgroundColor = useMemo(() => SIZE_COLORS[size] ?? '#757575', [size]);
  const classes = useStyles({ backgroundColor });

  return <Chip className={classes.root} size="small" label={size} />;
}
